import { render } from "./Privacidad.vue?vue&type=template&id=cbea3750"
import script from "./Privacidad.vue?vue&type=script&lang=ts"
export * from "./Privacidad.vue?vue&type=script&lang=ts"
script.render = render

export default script